/**
 * Backend-dəki `slug.util.ts` ilə eyni qaydalar — panel istifadəçiyə saxlanacaq
 * slug-ın eynisini göstərsin deyə. Qaydanı dəyişəndə HƏR İKİ faylı dəyiş.
 */
const LETTER_MAP: Record<string, string> = {
  'Ə': 'E', 'ə': 'e',
  'Ç': 'C', 'ç': 'c',
  'Ğ': 'G', 'ğ': 'g',
  'ı': 'i', 'İ': 'I',
  'Ö': 'O', 'ö': 'o',
  'Ş': 'S', 'ş': 's',
  'Ü': 'U', 'ü': 'u',
};

const AZ_LETTERS = /[ƏəÇçĞğıİÖöŞşÜü]/g;
const COMBINING_MARKS = new RegExp('[\\u0300-\\u036f]', 'g');

export function slugify(input: string): string {
  if (!input) return '';

  return input
    .replace(AZ_LETTERS, (ch) => LETTER_MAP[ch] ?? ch)
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
    .replace(/-+$/g, '');
}
